export const PURCHASE_FEE_PERCENTAGE = 5;
export const REDEEM_FEE_PERCENTAGE = 5;
